/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Totp_Verify_Page_TitleInputs */

const fr_totp_verify_page_title = /** @type {(inputs: Totp_Verify_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vérification en deux étapes`)
};

/**

* @param {Totp_Verify_Page_TitleInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const totp_verify_page_title = /** @type {((inputs?: Totp_Verify_Page_TitleInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Totp_Verify_Page_TitleInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_totp_verify_page_title(inputs)
});